// import ImageGallery from "react-image-gallery";
// import "react-image-gallery/styles/css/image-gallery.css";

// import productSample01 from "../assets/product_sample/products_sample_01.jpeg";
// import productSample02 from "../assets/product_sample/products_sample_02.jpeg";
// import productSample03 from "../assets/product_sample/products_sample_03.jpeg";
// import productSample04 from "../assets/product_sample/products_sample_04.jpeg";
// import productSample05 from "../assets/product_sample/products_sample_05.jpeg";

// import productPurchase01 from "../assets/product_purchase/products_purchase_01.jpeg";
// import productPurchase02 from "../assets/product_purchase/products_purchase_02.jpeg";
// import productPurchase03 from "../assets/product_purchase/products_purchase_03.jpeg";

// import productDrying01 from "../assets/product_drying/product_drying_01.jpeg";
// import productDrying02 from "../assets/product_drying/product_drying_02.jpeg";
// import productDrying03 from "../assets/product_drying/product_drying_03.jpeg";

// import packing01 from "../assets/packing/packing_01.jpeg";
// import packing02 from "../assets/packing/packing_02.jpeg";
// import packing03 from "../assets/packing/packing_03.jpeg";
// import packing04 from "../assets/packing/packing_04.jpeg";
// import packing05 from "../assets/packing/packing_05.jpeg";
// import packing06 from "../assets/packing/packing_06.jpeg";
// import packing07 from "../assets/packing/packing_07.jpeg";
// import packing08 from "../assets/packing/packing_08.jpeg";

// import grading01 from "../assets/grading/grading_01.jpeg";
// import grading02 from "../assets/grading/grading_02.jpeg";
// import grading03 from "../assets/grading/grading_03.jpeg";
// import grading04 from "../assets/grading/grading_04.jpeg";
// import grading05 from "../assets/grading/grading_05.jpeg";
// import grading06 from "../assets/grading/grading_06.jpeg";

// const Products = () => {
//   const productSampleImg = [
//     { original: productSample01, thumbnail: productSample01 },
//     { original: productSample02, thumbnail: productSample02 },
//     { original: productSample03, thumbnail: productSample03 },
//     { original: productSample04, thumbnail: productSample04 },
//     { original: productSample05, thumbnail: productSample05 },
//   ];

//   const productPurchaseImg = [
//     { original: productPurchase01, thumbnail: productPurchase01 },
//     { original: productPurchase02, thumbnail: productPurchase02 },
//     { original: productPurchase03, thumbnail: productPurchase03 },
//   ];

//   const productDryingImg = [
//     { original: productDrying01, thumbnail: productDrying01 },
//     { original: productDrying02, thumbnail: productDrying02 },
//     { original: productDrying03, thumbnail: productDrying03 },
//   ];

//   const packingImg = [
//     { original: packing01, thumbnail: packing01 },
//     { original: packing02, thumbnail: packing02 },
//     { original: packing03, thumbnail: packing03 },
//     { original: packing04, thumbnail: packing04 },
//     { original: packing05, thumbnail: packing05 },
//     { original: packing06, thumbnail: packing06 },
//     { original: packing07, thumbnail: packing07 },
//     { original: packing08, thumbnail: packing08 },
//   ];

//   const gradingImg = [
//     { original: grading01, thumbnail: grading01 },
//     { original: grading02, thumbnail: grading02 },
//     { original: grading03, thumbnail: grading03 },
//     { original: grading04, thumbnail: grading04 },
//     { original: grading05, thumbnail: grading05 },
//     { original: grading06, thumbnail: grading06 },
//   ];

//   return (
//     <div style={{ backgroundColor: "#34d6eb", padding: "20px" }} id="products">
//       <div className="container">
//         <h4 className="text-center mb-4">Our Products</h4>
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "center",
//             gap: "20px",
//           }}
//         >
//           {[
//             "Product Samples",
//             "Product Purchase",
//             "Product Drying",
//             "Grading",
//             "Packing",
//           ].map((title, index) => (
//             <div
//               key={index}
//               style={{
//                 width: "300px",
//                 height: "400px",
//                 textAlign: "center",
//                 padding: "10px",
//                 backgroundColor: "#fff",
//                 borderRadius: "10px",
//                 boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
//               }}
//             >
//               <h6>{title}</h6>
//               <div style={{ height: "320px", overflow: "hidden" }}>
//                 <ImageGallery
//                   items={productSampleImg}
//                   showThumbnails={false}
//                   showFullscreenButton={false}
//                   showPlayButton={false}
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Products;

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

import productSample01 from "../assets/product_sample/products_sample_01.jpeg";
import productSample02 from "../assets/product_sample/products_sample_02.jpeg";
import productSample03 from "../assets/product_sample/products_sample_03.jpeg";
import productSample04 from "../assets/product_sample/products_sample_04.jpeg";
import productSample05 from "../assets/product_sample/products_sample_05.jpeg";

import productPurchase01 from "../assets/product_purchase/products_purchase_01.jpeg";
import productPurchase02 from "../assets/product_purchase/products_purchase_02.jpeg";
import productPurchase03 from "../assets/product_purchase/products_purchase_03.jpeg";

import productDrying01 from "../assets/product_drying/product_drying_01.jpeg";
import productDrying02 from "../assets/product_drying/product_drying_02.jpeg";
import productDrying03 from "../assets/product_drying/product_drying_03.jpeg";

import packing01 from "../assets/packing/packing_01.jpeg";
import packing02 from "../assets/packing/packing_02.jpeg";
import packing03 from "../assets/packing/packing_03.jpeg";
import packing04 from "../assets/packing/packing_04.jpeg";
import packing05 from "../assets/packing/packing_05.jpeg";
import packing06 from "../assets/packing/packing_06.jpeg";
import packing07 from "../assets/packing/packing_07.jpeg";
import packing08 from "../assets/packing/packing_08.jpeg";

import grading01 from "../assets/grading/grading_01.jpeg";
import grading02 from "../assets/grading/grading_02.jpeg";
import grading03 from "../assets/grading/grading_03.jpeg";
import grading04 from "../assets/grading/grading_04.jpeg";
import grading05 from "../assets/grading/grading_05.jpeg";
import grading06 from "../assets/grading/grading_06.jpeg";

const Products = () => {
  const productCategories = [
    {
      title: "Product Samples",
      images: [
        { original: productSample01, thumbnail: productSample01 },
        { original: productSample02, thumbnail: productSample02 },
        { original: productSample03, thumbnail: productSample03 },
        { original: productSample04, thumbnail: productSample04 },
        { original: productSample05, thumbnail: productSample05 },
      ],
    },
    {
      title: "Product Purchase",
      images: [
        { original: productPurchase01, thumbnail: productPurchase01 },
        { original: productPurchase02, thumbnail: productPurchase02 },
        { original: productPurchase03, thumbnail: productPurchase03 },
      ],
    },
    {
      title: "Product Drying",
      images: [
        { original: productDrying01, thumbnail: productDrying01 },
        { original: productDrying02, thumbnail: productDrying02 },
        { original: productDrying03, thumbnail: productDrying03 },
      ],
    },
    {
      title: "Grading",
      images: [
        { original: grading01, thumbnail: grading01 },
        { original: grading02, thumbnail: grading02 },
        { original: grading03, thumbnail: grading03 },
        { original: grading04, thumbnail: grading04 },
        { original: grading05, thumbnail: grading05 },
        { original: grading06, thumbnail: grading06 },
      ],
    },
    {
      title: "Packing",
      images: [
        { original: packing01, thumbnail: packing01 },
        { original: packing02, thumbnail: packing02 },
        { original: packing03, thumbnail: packing03 },
        { original: packing04, thumbnail: packing04 },
        { original: packing05, thumbnail: packing05 },
        { original: packing06, thumbnail: packing06 },
        { original: packing07, thumbnail: packing07 },
        { original: packing08, thumbnail: packing08 },
      ],
    },
  ];

  return (
    <div style={{ backgroundColor: "#34d6eb", padding: "20px" }} id="products">
      <div className="container">
        <div className="section-title">
          <h2 style={{textAlign:"center"}}>Products</h2>
          <h5 style={{textAlign:"center"}}>
            Explore our collection of products
          </h5>
        </div>
        <br></br>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          {productCategories.map((category, index) => (
            <div
              key={index}
              style={{
                width: "212px",
                height: "320px",
                textAlign: "center",
                padding: "10px",
                backgroundColor: "#fff",
                borderRadius: "10px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h5>{category.title}</h5>
              <div style={{ height: "240px", overflow: "hidden" }}>
                <ImageGallery
                  items={category.images}
                  showThumbnails={true}
                  showFullscreenButton={false}
                  showPlayButton={false}
                  autoPlay={true} // Auto-scroll enabled
                  slideInterval={1500} // Change slides every 3 seconds
                  infinite={true} // Infinite loop
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
